import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const ToolboxUndoNsk = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M2.3551 8.23822L3.0905 3.09052L8.1817 8.18172L3.034 8.91712C2.638 8.97372 2.2985 8.63422 2.3551 8.23822Z"
        fill={color}
      />
      <path
        d="M19.6359 4.36292L17.0906 6.90822C18.45 8.26872 19.2 10.077 19.2 12H22.8C22.8 9.11602 21.6774 6.40312 19.6359 4.36292Z"
        fill={color}
      />
      <path
        d="M12 1.20001C9.116 1.20001 6.4031 2.32261 4.3641 4.36291L6.9094 6.90821C9.6282 4.18941 14.3719 4.18941 17.0907 6.90821L19.636 4.36291C17.5969 2.32261 14.8851 1.20001 12 1.20001Z"
        fill={color}
      />
      <path
        d="M19.2 12C19.2 13.923 18.45 15.7313 17.0906 17.0906L19.6359 19.6359C21.6773 17.5968 22.8 14.8851 22.8 12H19.2Z"
        fill={color}
      />
      <path
        d="M17.0906 17.0906C14.3718 19.8094 9.6305 19.8094 6.9093 17.0906L4.364 19.6359C6.4031 21.6773 9.116 22.8 11.9999 22.8C14.8838 22.8 17.5968 21.6773 19.6358 19.6359L17.0906 17.0906Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

ToolboxUndoNsk.displayName = 'ToolboxUndoNsk';
